export default __webpack_public_path__ + "a1870ff1afa2c7efba920025444f1aca.mp3";